import type { ReactNode } from 'react';

/**
 * Generic table used by every module (Creators, Partnerships, Approvals,
 * Connectors, Activity...). A module supplies columns + rows; it never
 * writes its own <table> markup. This is what lets "add a module" stay
 * config-sized instead of component-sized.
 */
export interface ColumnDef<T> {
  key: string;
  header: string;
  render: (row: T) => ReactNode;
}

export function DataTable<T extends { id: string }>({
  columns,
  rows,
  onRowClick,
}: {
  columns: ColumnDef<T>[];
  rows: T[];
  onRowClick?: (row: T) => void;
}) {
  return (
    <table className="dt">
      <thead>
        <tr>
          {columns.map((c) => (
            <th key={c.key}>{c.header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id} onClick={() => onRowClick?.(row)}>
            {columns.map((c) => (
              <td key={c.key}>{c.render(row)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
